'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (val) {
  // Replace closing
  var re = /<\/\W*script/gi;
  return val.replace(re, '(/script');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-on-rails/node_package/lib/scriptSanitizedVal.js
// module id = 616
// module chunks = 0